import { useEffect, useMemo, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";

//components
import { MisSolicitudes } from "../MisSolicitudes";
import { ResolverSolicitudes } from "../ResolverSolicitudes";
import Modal from "../../modal/Modal";
import ButtonCustom from "../../CustomButtom/ButtonCustom";
import { 
  getDependencias, 
  getOrganizacionInicioProceso, 
  getReporteSolicitudes, 
  getUserSolicitudes, 
  resetDependencias,
  saveFiles,
  setFormInfo,
  setLoadingHD
} from "../../../slices";
import { instanceAxiosPrivate } from "../../../axios";
import { toast } from "react-toastify";
import { yupResolver } from "@hookform/resolvers/yup";
import { validationsSchemaHelpdesk } from "../../../utils/validationsSchemaHelpdesk";

export const Helpdesk = () => {
  //redux state
  const dispatch = useDispatch() 
  const {organizaciones,  matchGA, type_msj} = useSelector((state) => state.helpdesk)  
  const {perfil} = useSelector((state) => state.user)  
  //states
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [formularioFinal, setFormularioFinal] = useState(false);
  const [selects, setSelects] = useState([]);

  const validationSchema = useMemo(() => {
   return validationsSchemaHelpdesk(selects, matchGA);
  }, [selects, matchGA]);

  const defaultValues = {
      id_hd2_organizacion: '',
      area_nivel: '',
      title: '',
      description: '',
      destinatario: '',
      direccion: '',
      fecha_entrega: '',
      requiere_evidencia: '',
      type_msj: '',
      evidence: '',
    }

  const {
    control,
    reset,
    register,
    handleSubmit,
    formState: { errors },
    setValue
  } = useForm({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
    resolver: yupResolver(validationSchema),
    defaultValues
  });

  const onSubmit = async (data) => { 

    try { 
      dispatch(setLoadingHD(true));     
      if (!matchGA) {
      delete data.destinatario;
      delete data.direccion;
      delete data.fecha_entrega;
      delete data.requiere_evidencia;
      delete data.type_msj;
    }

      for (var key in data) {
        if (key.startsWith("evidence")) delete data[key];
        if (key.startsWith("area_nivel_")) delete data[key];
      };

      data.area_nivel =  selects.map(sel => sel.value);
      data.user_id = perfil.user_id
      data.user_register= perfil.user_id;

      await dispatch(setFormInfo(data))
      
      await dispatch(saveFiles())

      hideModalRequest()

    } catch (error) {
      dispatch(setLoadingHD(false));     
      toast.error(error.msg || 'Error al guardar archivos');
    }
  }

  // save file in window
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    //guardar el archivo
    const instA = new instanceAxiosPrivate();
    if (file) {
        instA.setItemGeneral("evidence", file);
    }
  };

  const getOrg = async () => {
    try {
      dispatch(setLoadingHD(true));
      await dispatch(getOrganizacionInicioProceso())
      dispatch(setLoadingHD(false));
    } catch (error) {
      toast.error(error.msg);
      dispatch(setLoadingHD(false));
    }
  }

  const getDependencies = async (value, level) => {
    setFormularioFinal(null);
    try {
      const resp = await dispatch(getDependencias(value));

      setSelects((prev) => {
        const updated = prev.slice(0, level); 
        if (updated[level - 1]) {
          updated[level - 1].value = value;
        }
        if (!resp.formulario) {
          updated.push({
            level,
            options: resp.data.map((d) => ({
              value: d.id,
              label: d.name_organizacion,
            })),
            value: '',
            required: true 
          });
          setFormularioFinal(false);
        } else {     
          setValue('destinatario', '');
          setValue('direccion', '');
          setValue('fecha_entrega', '');
          setValue('requiere_evidencia', '');
          setValue('type_msj', '');
          setFormularioFinal(true);
        }
            return updated;
        });

    } catch (error) {
      toast.error(error.msg);
    }
  };

  const hideModalRequest = async() => {
    setIsOpenModal(false)
    setSelects([])
    setFormularioFinal(false)
    reset({
        id_hd2_organizacion: '',
        area_nivel: '',
        title: '',
        description: '',
        destinatario: '',
        direccion: '',
        fecha_entrega: '',
        requiere_evidencia: '',
        type_msj: '',
        evidence: '',
    });
    dispatch(resetDependencias())
    delete window.evidence;
    await dispatch(getUserSolicitudes())
    await dispatch(getReporteSolicitudes())
  }

  useEffect(() => {
    getOrg()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  

  return (
    <>
      <Modal
        handleClose={hideModalRequest}
        isOpen={isOpenModal}
        header="Nueva Solicitud"
        invoiceNum={""}
        size="modal-lg"
      >
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="col-12"
        >
          <div className="row">
            <div className="col-12 col-md-12 col-lg-6">
              <div className="d-flex flex-row py-0 my-0 mt-2">
                <div className="input-group-prepend py-0">
                  <span className="input-group-text" id="basic-addon1">
                    Area
                  </span>
                </div>
                <div className="form-control py-0 px-0 m-0 border-0">
                  <Controller
                    control={control}
                    render={({ field: { onChange, value, name, ref } }) => {
                      const currentSelection =
                        organizaciones &&
                        organizaciones.find((c) => c.value === value);
                      const selectChange = (selected) => {
                        onChange(selected.value);
                        // dependecias
                        getDependencies(selected.value, 0);
                      };
                      return (
                        <Select
                          label=""
                          instaceId="selectbox"
                          ref={ref}
                          value={currentSelection}
                          name={name}
                          options={organizaciones}
                          theme={(theme) => ({
                            ...theme,
                            borderRadius: 0,
                          })}
                          className="react-select-container border-0"
                          onChange={selectChange}
                        />
                      );
                    }}
                    name="id_hd2_organizacion"
                  />
                </div>
              </div>
              {errors.id_hd2_organizacion && (
                <p className="py-0 my-0">
                  {
                    errors.id_hd2_organizacion?.type === "required" 
                    ? "Este campo es requerido" 
                    : errors.id_hd2_organizacion.message
                  }
                </p>
              )}
            </div>
          </div>
          <div className="row">
            {selects.map((sel, index) => (
              <div className="col-12 col-md-12 col-lg-6 mt-2" key={index}>
                <div className="d-flex flex-row py-0 my-0 mt-2">
                  <div className="input-group-prepend py-0">
                    <span className="input-group-text" id="basic-addon1">
                      Nivel
                    </span>
                  </div>
                  <div className="form-control py-0 px-0 m-0 border-0">
                    <Controller
                      control={control}
                      render={({ field: { onChange, name, ref } }) => {
                        const currentSelection = sel.options.find(
                          (o) => o.value === sel.value
                        );
                        const selectChange = (selected) => {
                          setSelects((prev) => {
                            const updated = [...prev];
                            updated[index].value = selected.value;
                            return updated;
                          });
                          getDependencies(selected.value, index + 1);
                          onChange(selected.value);
                        };

                        return (
                          <Select
                            label=""
                            instaceId="selectbox"
                            ref={ref}
                            value={currentSelection}
                            name={name}
                            onChange={selectChange}
                            options={sel.options}
                            theme={(theme) => ({
                              ...theme,
                              borderRadius: 0,
                            })}
                            className="react-select-container border-0"
                          />
                        );
                      }}
                      name={`area_nivel_${sel.level}`}
                    />
                  </div>
                </div>
                {errors[`area_nivel_${index}`] && (
                  <p className="py-0 my-0">
                    {
                      errors[`area_nivel_${index}`]?.type === "required" 
                      ? "Este campo es requerido" 
                      : errors[`area_nivel_${index}`].message
                    }
                  </p>
                )}
              </div>
            ))}
          </div>
          <div className="px-2">
            {formularioFinal && (
              <>             
                { 
                  matchGA  && (
                  <div className="row">
                    <div className="col-12 col-md-12 col-lg-6 px-1">
                      <div className="d-flex flex-row py-0 my-0 mt-2">
                        <div className="input-group-prepend py-0">
                          <span className="input-group-text" id="basic-addon1">
                            Labor a realizar
                          </span>
                        </div>
                        <div className="form-control py-0 px-0 m-0 border-0">
                          <Controller
                            control={control}
                            render={({
                              field: { onChange, value, name, ref },
                            }) => {
                              const currentSelection =
                                type_msj &&
                                type_msj.find((c) => c.value === value);
                              const selectChange = (selected) => {
                                onChange(selected.value);
                              };
                              return (
                                <Select
                                  label=""
                                  instaceId="selectbox"
                                  ref={ref}
                                  value={currentSelection}
                                  name={name}
                                  options={type_msj}
                                  theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 0,
                                  })}
                                  className="react-select-container border-0"
                                  onChange={selectChange}
                                />
                              );
                            }}
                            name="type_msj"
                          />
                        </div>
                      </div>
                      {errors.type_msj && (
                        <p className="py-0 my-0">
                          {
                            errors.type_msj?.type === "required" 
                            ? "Este campo es requerido" 
                            : errors.type_msj.message
                          }
                        </p>
                      )}
                    </div>
                    <div className="col-12 col-md-12 col-lg-6 px-1">
                      <div className="d-flex flex-row py-0 my-0 mt-2">
                        <div className="input-group-prepend py-0">
                          <span className="input-group-text" id="basic-addon1">
                            Destinatario
                          </span>
                        </div>
                        <div className="form-control py-0 px-0 m-0 border-0">
                          <input
                            type="text"
                            id="destinatario"
                            {...register("destinatario")}
                            className="form-control"
                          />
                        </div>
                      </div>
                      {errors.destinatario && (
                        <p className="py-0 my-0">
                          {
                            errors.destinatario?.type === "required" 
                            ? "Este campo es requerido" 
                            : errors.destinatario.message
                          }
                        </p>
                      )}
                    </div>
                    <div className="col-12 col-md-12 col-lg-6 px-1">
                      <div className="d-flex flex-row py-0 my-0 mt-2">
                        <div className="input-group-prepend py-0">
                          <span className="input-group-text" id="direccion">
                            Direccion
                          </span>
                        </div>
                        <div className="form-control py-0 px-0 m-0 border-0">
                          <input
                            type="text"
                            id="direccion"
                            {...register("direccion")}                            
                            className="form-control"
                          />
                        </div>
                      </div>
                      {errors.direccion && (
                        <p className="py-0 my-0">
                          {
                            errors.direccion?.type === "required" 
                            ? "Este campo es requerido" 
                            : errors.direccion.message
                          }
                        </p>
                      )}
                    </div>
                    <div className="col-12 col-md-12 col-lg-6 px-1">
                      <div className="d-flex flex-row py-0 my-0 mt-2">
                        <div className="input-group-prepend py-0">
                          <span className="input-group-text" id="fecha_entrega">
                            Fecha de entrega
                          </span>
                        </div>
                        <div className="form-control py-0 px-0 m-0 border-0">
                          <input
                            type="date"
                            id="fecha_entrega"
                            {...register("fecha_entrega")}                            
                            className="form-control"
                          />
                        </div>
                      </div>
                      {errors.fecha_entrega && (
                        <p className="py-0 my-0">
                          {
                            errors.fecha_entrega?.type === "required" 
                            ? "Este campo es requerido" 
                            : errors.fecha_entrega.message
                          }
                        </p>
                      )}
                    </div>
                    <div className="col-12 col-md-12 col-lg-6 px-1">
                      <div className="d-flex flex-row py-0 my-0 mt-2">
                        <div className="input-group-prepend py-0">
                          <span className="input-group-text" id="requiere_evidencia">
                            Requiere Evidencia
                          </span>
                        </div>
                        <div className="form-control py-0 px-0 m-0 border-0">
                          <Controller
                            control={control}
                            render={({
                              field: { onChange, value, name, ref },
                            }) => {
                              const options = [
                                { label: "SI", value: "SI" },
                                { label: "NO", value: "NO" },
                              ];
                              const currentSelection = options.find(
                                (c) => c.value === value
                              );
                              const selectChange = (selected) => {
                                onChange(selected.value);
                              };
                              return (
                                <Select
                                  label=""
                                  instaceId="selectbox"
                                  ref={ref}
                                  value={currentSelection}
                                  name={name}
                                  options={options}
                                  theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 0,
                                  })}
                                  className="react-select-container border-1"
                                  onChange={selectChange}
                                />
                              );
                            }}
                            name="requiere_evidencia"
                          />
                        </div>
                      </div>
                      {errors.requiere_evidencia && (
                        <p className="py-0 my-0">
                          {
                            errors.requiere_evidencia?.type === "required" 
                            ? "Este campo es requerido" 
                            : errors.requiere_evidencia.message
                          }
                        </p>
                      )}
                    </div>
                  </div>
                  )
                }
                <div className="row">
                  <div className="col-12 col-md-12 px-1">
                    <div className="d-flex flex-row py-0 my-0 mt-2">
                      <div className="input-group-prepend py-0">
                        <span className="input-group-text" id="title">
                          Titulo
                        </span>
                      </div>
                      <div className="form-control py-0 px-0 m-0 border-0">
                        <input
                          type="text"
                          id="title"
                          {...register("title")}                          
                          className="form-control border-1"
                        />
                      </div>
                    </div>
                    {errors.title && (
                        <p className="py-0 my-0">
                          {
                            errors.title?.type === "required" 
                            ? "Este campo es requerido" 
                            : errors.title.message
                          }
                        </p>
                      )}
                  </div>
                  <div className="col-12 col-md-12 px-1">
                    <div className="d-flex flex-row py-0 my-0 mt-2">
                      <div className="input-group-prepend py-0">
                        <span className="input-group-text" id="description">
                          Descripcion
                        </span>
                      </div>
                      <div className="form-control py-0 px-0 m-0 border-0">
                        <Controller
                          control={control}
                          render={({ field: { onChange, value, name } }) => {
                            const selectChange = (selected) => {
                              onChange(selected.target.value);
                            };
                            return (
                              <textarea
                                onChange={selectChange}
                                value={value}
                                name={name}
                                className="form-control"
                                height="38"
                              />
                            );
                          }}
                          name="description"
                        />
                      </div>
                    </div>
                    {errors.description && (
                        <p className="py-0 my-0">
                          {
                            errors.description?.type === "required" 
                            ? "Este campo es requerido" 
                            : errors.description.message
                          }
                        </p>
                      )}
                  </div>
                  <div className="col-12 col-md-12 px-1">
                    <div className="d-flex flex-row py-0 my-0 mt-2">
                      <div className="input-group-prepend py-0">
                        <span className="input-group-text">
                          Adjunto
                        </span>
                      </div>
                      <div className="form-control py-0 px-0 m-0 border-0">
                        <Controller
                          name={"evidence"}
                          control={control}
                          render={({ field: { onChange, ref } }) => (
                            <>
                              <input
                                type="file"
                                id={"evidence"}
                                className="form-control"
                                onChange={(event) => {
                                  onChange(event.target.files[0]);
                                  handleFileChange(event);
                                }}
                                ref={ref}
                              />                              
                            </>
                          )}
                        />
                      </div>
                    </div>                    
                  </div>
                </div>
              </>
            )}
          </div>

          <div className="row px-1 mt-2">
            <div className="col-12 px-0">
              <ButtonCustom
                type="button"
                classnames="btn btn-danger py-2 px-4 text-white fw-bold m-1"
                onClick={handleSubmit(onSubmit)} 
              >
                Nueva Solicitud
              </ButtonCustom>
            </div>
          </div>
        </form>
      </Modal>

      <div className="row">
        <div className="col-12">
          <div className="row my-2">
            <div className="col-sm-6">
              <h1 className="m-0">Helpdesk</h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item active">Helpdesk</li>
              </ol>
            </div>
          </div>
          <div className="row my-2">
            <div className="col-md-12 my-3">
              <ButtonCustom
                type="button"
                classnames="btn btn-sm btn-danger py-2 px-4 text-white fw-bold m-1"
                onClick={() => setIsOpenModal(true)}
              >
                Nueva Solicitud
              </ButtonCustom>
            </div>
          </div>
          <div className="row">
            <MisSolicitudes />
          </div>
          <div className="row mt-3 mb-3">
            <ResolverSolicitudes />
          </div>
        </div>
      </div>
    </>
  );
};
